<template>
  <div class="flex items-center gap-1">
    <slot v-if="value" name="onIcon"><img src="@/assets/icons/radio_on.svg" /></slot>
    <slot v-else name="offIcon"><img src="@/assets/icons/radio_off.svg" /></slot>
    <p v-if="!!label" class="flex-1">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: "PrintRadio",
  props: {
    label: String,
    value: Boolean,
    color: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
